import React from 'react';

export const ConsentContext = React.createContext([]);

class OneTrustWrapper extends React.Component {

  domainId = '019c9457-f4cb-7454-90bc-02ac1c1468b2';

  constructor(props) {
    super(props);
    this.state = {
      activeGroups: [],
      isLoaded: false
    };
    this.updateConsent = this.updateConsent.bind(this);
  }

  componentDidMount() {
    if (!document.getElementById('one-trust-sdk')) {
      const script = document.createElement('script');
      script.id = 'one-trust-sdk';
      script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      script.type = 'text/javascript';
      script.charset = 'UTF-8';
      script.setAttribute('data-domain-script', this.domainId);
      document.head.prepend(script);
    }

    window.OptanonWrapper = () => {
      this.updateConsent();
    };
  }

  updateConsent() {
    if (window.OnetrustActiveGroups) {
      console.log("von OneTrust:", window.OnetrustActiveGroups);
      const groups = window.OnetrustActiveGroups.split(',');
      console.log("activeGroups:", groups);
      this.setState({
        activeGroups: groups,
        isLoaded: true
      });
    } else {
      console.log("OneTrust geladen activeGroups leer.");
    }
  }

  render() {
    return React.createElement(
      ConsentContext.Provider,
      {value: this.state.activeGroups},
      this.props.children
    );
  }
}

export default OneTrustWrapper;
